import React, { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';

import RoleRestrictedRoute from 'utility/routing/RoleRestrictedRoute';
import IPPoolDetailsLayout from 'components/IPPoolDetailsLayout';
import { roles } from 'utility/constants/roles';

const CloudIPAddresses = lazy(() => import('pages/network/CloudIPAddresses'));
const IpPoolOverview = lazy(() => import('pages/network/IPPools/Overview'));
const IpPoolActivity = lazy(() => import('pages/network/IPPools/Activity'));
const GlobalPrivateFabric = lazy(
	() => import('pages/network/GlobalPrivateFabric'),
);
const FabricDetails = lazy(
	() => import('pages/network/GlobalPrivateFabric/FabricDetails'),
);
const FabricServers = lazy(
	() => import('pages/network/GlobalPrivateFabric/FabricDetails/FabricServers'),
);
const FabricVpnInterconnects = lazy(
	() =>
		import(
			'pages/network/GlobalPrivateFabric/FabricDetails/FabricVpnInterconnects'
		),
);
const NotFound = lazy(() => import('pages/NotFound'));

const NetworkRouter = () => {
	return (
		<Switch>
			<RoleRestrictedRoute
				exact
				path="/network/global-private-fabric"
				component={GlobalPrivateFabric}
			/>
			<Route path="/network/global-private-fabric/:fabricId">
				<FabricDetails>
					<Switch>
						<RoleRestrictedRoute
							exact
							path="/network/global-private-fabric/:fabricId/servers"
							component={FabricServers}
						/>
						<RoleRestrictedRoute
							exact
							path="/network/global-private-fabric/:fabricId/vpn-interconnects"
							component={FabricVpnInterconnects}
						/>
						<RoleRestrictedRoute
							exact
							path="/network/global-private-fabric/:fabricId"
							component={FabricServers}
						/>
					</Switch>
				</FabricDetails>
			</Route>
			<RoleRestrictedRoute
				exact
				path="/network/cloud-ip-addresses"
				component={CloudIPAddresses}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<Route path="/network/cloud-ip-addresses/:uniqId">
				<IPPoolDetailsLayout>
					<Switch>
						<RoleRestrictedRoute
							exact
							path="/network/cloud-ip-addresses/:uniqId"
							component={IpPoolOverview}
							whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
						/>
						<RoleRestrictedRoute
							exact
							path="/network/cloud-ip-addresses/:uniqId/activity"
							component={IpPoolActivity}
							whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
						/>
					</Switch>
				</IPPoolDetailsLayout>
			</Route>
			<Route>
				<NotFound />
			</Route>
		</Switch>
	);
};

export default NetworkRouter;
